
import { Card, CardContent } from "@/components/ui/card";

const papers = [
  {
    title: "hEARt: Motion-resilient Heart Rate Monitoring with In-ear Microphones",
    authors: "Butkow et al., 2023",
    journal: "2023 IEEE International Conference on Pervasive Computing and Communications (PerCom)",
    link: "https://ieeexplore.ieee.org/abstract/document/10099317"
  },
  {
    title: "An evaluation of heart rate monitoring with in-ear microphones under motion",
    authors: "Butkow et al., 2024",
    journal: "Pervasive and Mobile Computing",
    link: "https://www.sciencedirect.com/science/article/pii/S1574119224000397"
  },
  {
    title: "RespEar: Earable-Based Robust Respiratory Rate Monitoring",
    authors: "Liu and Butkow et al., 2024",
    journal: "2025 IEEE International Conference on Pervasive Computing and Communications (PerCom)",
    link: "https://arxiv.org/abs/2407.06901"
  },
  {
    title: "Measuring cardiac stroke volume through in-ear audio sensing",
    authors: "Butkow et al., 2026",
    journal: "Nature Communications",
    link: "https://www.nature.com/articles/s41467-026-75642-0"
  },
];

export const ResearchSection = () => {
  return (
    <section id="research" className="py-20 px-4 section-dark">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-white">Backed by Research</h2>
        
        <p className="text-lg text-center text-white/70 mb-16 max-w-3xl mx-auto">
          Our technology is built on world-leading research in biomedical signal processing and machine learning, validated through rigorous testing and academic peer review.
        </p>
        
        <div>
          <h3 className="text-2xl font-semibold mb-8 text-white">Publications</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {papers.map((paper) => (
              <a 
                href={paper.link}
                target="_blank"
                rel="noopener noreferrer"
                key={paper.title}
                className="h-full"
              >
                <Card className="h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#ffa05d]/50 hover:bg-white/10">
                  <CardContent className="p-6 flex flex-col justify-between h-full">
                    <div>
                      <h4 className="text-xl font-semibold mb-4 text-white">{paper.title}</h4>
                      <p className="text-[#A4CBA6] mb-2">{paper.authors}</p>
                      <p className="text-sm text-white/60">{paper.journal}</p>
                    </div>
                  </CardContent>
                </Card>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
